import React from 'react'
import CardTitle from '../../Component/common/card/CardTitle'
import MUICard from '../../Component/common/card/MUICard'
import SurveyList from './SurveyList'

export default function SurveyWrapper() {
    return (
        <MUICard
            header={
                <CardTitle>
                    Survey
                </CardTitle>
            }
        >
            <SurveyList />
        </MUICard>
    )
}